export default __webpack_public_path__ + "static/media/Carla.d5530bbb.jpeg";